import { useEffect, useState,useContext } from 'react';
import $ from "jquery";
import {Accordion, Button, ListGroup} from 'react-bootstrap';
import {BsPeople,BsInboxesFill} from 'react-icons/bs';
import Spinner from 'react-bootstrap/Spinner';
import {
    useNavigate
  } from "react-router-dom";
  import UserContext from '../../contexts/UserContext';

const Attendance = ()=>{
const navigate = useNavigate();
const [blocks,setBlocks] = useState([]);
const [count,setCount] = useState(0);
const [flatForAblock,setAflats] = useState([]);
const [flatForBblock,setBflats] = useState([]);
const [flatForCblock,setCflats] = useState([]);
const [flatForDblock,setDflats] = useState([]);
const [others,setOthers] = useState([]);
const totalDataA=[];
const totalDataB=[];
const totalDataC=[];
const totalDataD=[];
const totalDataOthers=[];
const [totalcount,setTotalCount]=useState({count:0,persons:0});
const [isLoading, setLoading] = useState(true);
const {user,setUser} = useContext(UserContext);
const options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };

  const getUser = async (userId) => {
    await $.ajax({
        type:"GET",
        url:process.env.REACT_APP_API_URL+"/getUsers/"+userId,
        xhrFields: {
            withCredentials: true  // Include cookies
          },
          crossDomain: true, 
         success : async function(response){
          if(response && response.user){
             await setUser(response.user);
          }else{
            setUser(null)
            navigate("/login")
          }
        },
        error: function(err){
            console.log("error")
            console.log(err)
        }
    })
}


  function getFileData(){
    $.ajax({
        type:"GET",
        url:process.env.REACT_APP_API_URL+"/getDatas",
        xhrFields: {
            withCredentials: true  // Include cookies
          },
          crossDomain: true, 
         success : function(response){
            if(response.message  && response.message.includes("Error in auth")){
                navigate("/login",{state: { message: response.message }})
            }
            setBlocks(['A BLOCK','B BLOCK','C BLOCK','D BLOCK','Others']);
            setAflats(response.blockA);
            setBflats(response.blockB);
            setCflats(response.blockC);
            setDflats(response.blockD);
            setOthers(response.others);
            setLoading(false);
        },
        error: function(err){
            console.log("error")
            console.log(err)
            setLoading(false);
            navigate("/login")
        }
    })
}


useEffect(
    ()=>{
        try{
        if(!user && localStorage.getItem('userSession')){
            getUser(JSON.parse(localStorage.getItem('userSession')))
          }else{
            if(!user){
              navigate("/login")
            }
        }
        }catch(e){
            if(!user){
                navigate("/login")
            }
        }
        getFileData();
    }
,[]);

const updateListA = (e) => {
    if(e.target.checked){
        e.target.parentNode.parentNode.style.backgroundColor = "#FFC26F"
        totalDataA.push(e.target.value);
    }else{
        e.target.parentNode.parentNode.style.backgroundColor = "white"
        if(totalDataA.includes(e.target.value)){
            totalDataA.splice(totalDataA.indexOf(e.target.value), 1);
        }
    }
}

const updateListB = (e) => {
    if(e.target.checked){
        e.target.parentNode.parentNode.style.backgroundColor = "#FFC26F"
        totalDataB.push(e.target.value);
    }else{
        e.target.parentNode.parentNode.style.backgroundColor = "white"
        if(totalDataB.includes(e.target.value)){
            totalDataB.splice(totalDataB.indexOf(e.target.value), 1);
        }
    }
}

const updateListC = (e) => {
    if(e.target.checked){
        e.target.parentNode.parentNode.style.backgroundColor = "#FFC26F"
        totalDataC.push(e.target.value);
    }else{
        e.target.parentNode.parentNode.style.backgroundColor = "white"
        if(totalDataC.includes(e.target.value)){
            totalDataC.splice(totalDataC.indexOf(e.target.value), 1);
        }
    }
}

const updateListD = (e) => {
    if(e.target.checked){
        e.target.parentNode.parentNode.style.backgroundColor = "#FFC26F"
        totalDataD.push(e.target.value);
    }else{
        e.target.parentNode.parentNode.style.backgroundColor = "white"
        if(totalDataD.includes(e.target.value)){
            totalDataD.splice(totalDataD.indexOf(e.target.value), 1);
        }
    }
}

const updateOthers = (e) => {
    if(e.target.checked){
        e.target.parentNode.parentNode.style.backgroundColor = "#FFC26F"
        totalDataOthers.push(e.target.value);
    }else{
        e.target.parentNode.parentNode.style.backgroundColor = "white"
        if(totalDataOthers.includes(e.target.value)){
            totalDataOthers.splice(totalDataOthers.indexOf(e.target.value), 1);
        }
    }
}

const sendData = () => {
    setAflats((flats)=>{
        flats.map((flat)=>{
            if(totalDataA.includes(flat.block)){
                flat.tick=true;
                setTotalCount((total)=>{return {count:total.count+1,persons:total.persons+Number(flat.members)}})
            }
        })
        return flats;
    })
    setBflats((flats)=>{
        flats.map((flat)=>{
            if(totalDataB.includes(flat.block)){
                flat.tick=true;
                setTotalCount((total)=>{return {count:total.count+1,persons:total.persons+Number(flat.members)}})
            }
        })
        return flats;
    })
    setCflats((flats)=>{
        flats.map((flat)=>{
            if(totalDataC.includes(flat.block)){
                flat.tick=true;
                setTotalCount((total)=>{return {count:total.count+1,persons:total.persons+Number(flat.members)}})
            }
        })
        return flats;
    })
    setDflats((flats)=>{
        flats.map((flat)=>{
            if(totalDataD.includes(flat.block)){
                flat.tick=true;
                setTotalCount((total)=>{return {count:total.count+1,persons:total.persons+Number(flat.members)}})
            }
        })
        return flats;
    })
    setOthers((flats)=>{
        flats.map((flat)=>{
            if(totalDataOthers.includes(flat.block)){
                flat.tick=true;
                setTotalCount((total)=>{return {count:total.count+1,persons:total.persons+Number(flat.members)}})
            }
        })
        return flats;
    })
}

function sendDataRequest(){
    setLoading(true);
    $.ajax({
        type:"POST",
        url:process.env.REACT_APP_API_URL+"/tiffinCount",
        data:{flatForAblock,flatForBblock,flatForCblock,flatForDblock,others,totalcount},
        dataType: 'json',
        xhrFields: {
            withCredentials: true  // Include cookies
          },
          crossDomain: true, 
         success : function(response){
            if(response.message  && response.message.includes("Error in auth")){
                navigate("/login");
              }
              setLoading(false);
              navigate("/attendanceCount")
          
        },
        error: function(err){
            console.log("error")
            console.log(err) 
            
            navigate(0)
            setLoading(false);
        }
    })
}

function getFractionValue(value){
    switch(value){
        case 0 : return "Not needed";
        case 0.25 : return "1/4 Dabba";
        case 0.5 : return "1/2 Dabba";
        case 0.75 : return "3/4 Dabba";
        case 1 : return "Full Dabba";
        default : return null;
    }
}

const AccordionBlock = (block) => {
    const AccordionBlockDesign = (
    <>
        <Accordion.Item eventKey={block}>
                <Accordion.Header>{block.data === 'Others'?'Aamil Saab & Atraaf':block.data}</Accordion.Header>
                
                <Accordion.Body>
                    <ListGroup>
                        {
                           (block.data==='A BLOCK')?
                            (flatForAblock.map((flat,i)=>{
                                return <ListGroup><ListGroup.Item key={i} className='d-flex justify-content-between' style={{color:'#361e17!important'}}>
                                    <div className='d-flex align-items-center' >
                                    <input className='me-1'  type="checkbox" id={flat.block} name={flat.block} checked={flat.tick} value={flat.block} onChange={updateListA} />
                                    {flat.block}
                                    </div>
                                    <div className='font-size-sm mx-2'><label htmlFor={flat.block} >{flat.name.split(" ").pop()}</label></div>
                                    <div className='d-flex align-items-center'> 
                                    <BsPeople className='mx-1' />
                                        {flat.members}
                                    </div>
                                    </ListGroup.Item>
                                    {flat.rsvpData.find((rsvp)=>rsvp.date===new Date().toDateString())?
                                    flat.rsvpData.find((rsvp)=>rsvp.date===new Date().toDateString()).menu.map((menu)=>{
                                        return <ListGroup.Item>
                                            {menu.name} : {getFractionValue(menu.value)}
                                            </ListGroup.Item>
                                    })
                                    :null}      
                                    </ListGroup>
                            })):(block.data==='B BLOCK')?
                            (flatForBblock.map((flat,i)=>{
                                return <ListGroup><ListGroup.Item key={i} className='d-flex justify-content-between'>
                                    <div className='d-flex align-items-center'>
                                    <input className='me-1'  type="checkbox" id={flat.block} name={flat.block} checked={flat.tick} value={flat.block} onChange={updateListB} />
                                    {flat.block}
                                    </div>
                                    <div className='font-size-sm mx-2'><label htmlFor={flat.block} >{flat.name.split(" ").pop()}</label></div>
                                    <div className='d-flex align-items-center'> 
                                    <BsPeople className='mx-1' />
                                        {flat.members}
                                    </div>
                                    </ListGroup.Item>
                                    {flat.rsvpData.find((rsvp)=>rsvp.date===new Date().toDateString())?
                                        flat.rsvpData.find((rsvp)=>rsvp.date===new Date().toDateString()).menu.map((menu)=>{
                                            return <ListGroup.Item>
                                                {menu.name} : {getFractionValue(menu.value)}
                                                </ListGroup.Item>
                                        })
                                        :null}      
                                        </ListGroup>
                            })):(block.data==='C BLOCK')?
                            (flatForCblock.map((flat,i)=>{
                                return <ListGroup><ListGroup.Item key={i} className='d-flex justify-content-between'>
                                    <div className='d-flex align-items-center'>
                                    <input className='me-1'  type="checkbox" id={flat.block} name={flat.block} checked={flat.tick} value={flat.block} onChange={updateListC} />
                                    {flat.block}
                                    </div>
                                    <div className='font-size-sm mx-2'><label htmlFor={flat.block} >{flat.name.split(" ").pop()}</label></div>
                                    <div className='d-flex align-items-center'> 
                                    <BsPeople className='mx-1' />
                                        {flat.members}
                                    </div>
                                    </ListGroup.Item>
                                    {flat.rsvpData.find((rsvp)=>rsvp.date===new Date().toDateString())?
                                        flat.rsvpData.find((rsvp)=>rsvp.date===new Date().toDateString()).menu.map((menu)=>{
                                            return <ListGroup.Item>
                                                {menu.name} : {getFractionValue(menu.value)}
                                                </ListGroup.Item>
                                        })
                                        :null}      
                                        </ListGroup>
                            })):(block.data==='D BLOCK')?
                            (flatForDblock.map((flat,i)=>{
                                return <ListGroup><ListGroup.Item key={i} className='d-flex justify-content-between'>
                                    <div className='d-flex align-items-center'>
                                    <input className='me-1'  type="checkbox" id={flat.block} name={flat.block} checked={flat.tick} value={flat.block} onChange={updateListD} />
                                    {flat.block}
                                    </div>
                                    <div className='font-size-sm mx-2'><label htmlFor={flat.block} >{flat.name.split(" ").pop()}</label></div>
                                    <div className='d-flex align-items-center'> 
                                    <BsPeople className='mx-1' />
                                        {flat.members}
                                    </div>
                                    </ListGroup.Item>
                                    {flat.rsvpData.find((rsvp)=>rsvp.date===new Date().toDateString())?
                                    flat.rsvpData.find((rsvp)=>rsvp.date===new Date().toDateString()).menu.map((menu)=>{
                                        return <ListGroup.Item>
                                            {menu.name} : {getFractionValue(menu.value)}
                                            </ListGroup.Item>
                                    })
                                    :null}      
                                    </ListGroup>
                            })):(block.data==='Others')?
                            (others.map((flat,i)=>{
                                return <ListGroup><ListGroup.Item key={i} className='d-flex justify-content-between'>
                                    <div className='d-flex align-items-center'>
                                    <input className='me-1'  type="checkbox" id={flat.block} name={flat.block} checked={flat.tick} value={flat.block} onChange={updateOthers} />
                                    {flat.block}
                                    </div>
                                    <div className='font-size-sm mx-2'><label htmlFor={flat.block} >{flat.name.split(" ").pop()}</label></div>
                                    <div className='d-flex align-items-center'> 
                                    <BsPeople className='mx-1' />
                                        {flat.members}
                                    </div>
                                    </ListGroup.Item>
                                    {flat.rsvpData.find((rsvp)=>rsvp.date===new Date().toDateString())?
                                    flat.rsvpData.find((rsvp)=>rsvp.date===new Date().toDateString()).menu.map((menu)=>{
                                        return <ListGroup.Item>
                                            {menu.name} : {getFractionValue(menu.value)}
                                            </ListGroup.Item>
                                    })
                                    :null}      
                                    </ListGroup>
                            })):null
                          
                        }
                    </ListGroup>
                </Accordion.Body>
        </Accordion.Item>
    </>
    )
    return AccordionBlockDesign;
}

const Block = ()=>{
     const blockDesign=(
        <>
            <Accordion>
            {
                blocks.map((block,index)=>{
                    return <AccordionBlock data={block} key={index}/>
                })
            }
            </Accordion>
        </>
    
    )
return blockDesign;
}

const design = (
    <>
    <div className='d-flex justify-content-between mt-3 mx-3'>
        <div>
            <h6>{new Date().toLocaleString("en-US", options)}</h6>
        </div>
        <div className='mb-1'>
            <BsInboxesFill /> {totalcount.count} 
            <BsPeople className='ms-2'/> {totalcount.persons}
        </div>
    </div>

    <Block/>

    <div className='d-flex mx-3 my-3 justify-content-end'>
        <Button className='w-100' variant='secondary' onClick={sendData}> Save </Button>
    </div>

    <div className='d-flex mx-3 justify-content-end'>
        <Button className='w-100' style={{backgroundColor:'#884A39',borderColor:'#884A39'}} onClick={()=>{sendDataRequest()}}> Submit </Button>
    </div>
    </>
);
return isLoading? <div className="mx-auto mt-5" style={{width: "30px"}}><Spinner className="mx-auto " style={{color:'brown'}} animation="border" role="status">
</Spinner><br/>
<span style={{marginLeft:'-10px'}}>Loading...</span></div>:design;
}

export default Attendance;